module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search_transactions":"Search Transactions","filter_transactions":"Filter Transactions","clear_filters":"Clear filters","no_transaction_found":"No transaction found"},"id":{"search_transactions":"Cari Transaksi","filter_transactions":"Filter Transaksi","clear_filters":"Hapus filter","no_transaction_found":"Tiada transaksi ditemukan"}}')
  delete Component.options._Ctor
}
